import type {
  InvitationOutreachCompletePayload,
  InvitationOutreachFailedPayload,
  InvitationOutreachUnknownPayload,
} from '@fluenceur/types';
import { BrandEventPusherService } from './brand-event-pusher-service';

export const invitationOutreachPusherService = new BrandEventPusherService<
  InvitationOutreachCompletePayload,
  InvitationOutreachFailedPayload,
  InvitationOutreachUnknownPayload
>({
  debugLabel: 'InvitationOutreachPusher',
  completeEvent: 'invitation-outreach-complete',
  failedEvent: 'invitation-outreach-failed',
  unknownEvent: 'invitation-outreach-unknown',
});
